export default __webpack_public_path__ + "static/financial_preparing-dd041d8a100da00a6955ecb801a39be7.png";